import { render, staticRenderFns } from "./ZhanhuiList.vue?vue&type=template&id=0dfc8434&scoped=true"
import script from "./ZhanhuiList.vue?vue&type=script&lang=js"
export * from "./ZhanhuiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc8434",
  null
  
)

export default component.exports